import React, { Component } from "react";

import Menu from "Menu/Menu";
import MediaViewer from "Reveal/MediaViewer";
import ArticleViewer from "Reveal/ArticleViewer";
import MailViewer from "Reveal/MailViewer";
import ClientEboxViewer from "Reveal/ClientEboxViewer";
import TopicViewer from "Reveal/TopicViewer";
import PDFViewer from "Reveal/PDFViewer/PDFViewer";
import FlashMessage from "./FlashMessage";

import Footer from "./Footer";

export default class Layout extends Component {
  componentDidMount() {
    //$(document).foundation();
  }

  render() {
    return (
      <div className="off-canvas-wrapper">
        <Menu />
        {this.props.children}
        <Footer />
        <PDFViewer />
        <ArticleViewer />
        <MailViewer />
        <ClientEboxViewer />
        <TopicViewer />
        <MediaViewer />
        <FlashMessage />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js